import createInstance from './create-instance';

export const { css, cache } = createInstance( { key: 'css' });
